import { ISODateTimeString } from '../../../shared/ISODateTimeString';
import { eDepositCategory } from '../eDepositCategory';
import { eMatchedQueryValue } from '../../../accounting/eMatchedQueryValue';
import { IWireDepositData } from '../IWireDepositData';
import { IEscrowFileData } from '../../../accounting/data/IEscrowFileData';
import { IEscrowActualIncomingWireData } from './IActualIncomingWireData';
import { IEscrowBankAccountResponse } from '../../../accounting/response/IEscrowBankAccountResponse';
import { ePayerType } from '../ePayerType';
import { IEscrowActualIncomingWireResponse } from '../../../accounting/response/IEscrowActualIncomingWiresResponse';

export interface IWireDepositResponse {
  id: string;
  createdAt: ISODateTimeString;
  createdBy: string;
  updatedAt: ISODateTimeString;
  updatedBy?: string;
  amountCents: number;
  category: eDepositCategory;
  payerType: ePayerType;
  wireIdentifier?: string;
  escrowFile: IEscrowFileData;
  actualIncomingWire?: IEscrowActualIncomingWireData;
  matched: eMatchedQueryValue;
  matchedBy: string;
  matchedAt: string;
}

export const convertIWireDepositResponseDataToIWireDepositData = (
  escrowBankAccount: IEscrowBankAccountResponse,
  {
    id,
    amountCents,
    category,
    payerType,
    wireIdentifier,
    actualIncomingWire,
    matched,
    createdAt,
    createdBy,
    updatedAt,
    updatedBy,
    matchedBy,
    matchedAt,
  }: IWireDepositResponse
): IWireDepositData => ({
  id,
  amountCents,
  payerType,
  wireIdentifier,
  category,
  escrowBankAccount: escrowBankAccount,
  actualIncomingWire: actualIncomingWire as IEscrowActualIncomingWireResponse | undefined,
  actualWireDetail: actualIncomingWire?.wireDetail,
  createdAt,
  createdBy,
  updatedAt,
  updatedBy,
  matched,
  completedAtDate: actualIncomingWire?.completedAtDate,
  matchedBy,
  matchedAt,
});
